export const FULL = 'FULL';
export const READ = 'READ';
export const WRITE = 'WRITE';
